<template>
  <div class="background">
    <div class="chart-container" id="container">
      <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <img src="../../assets/LOGO.png">
        </div>
        <div class="main-header-right">
          <p>{{$t('Alerts Report')}}</p>
          <p style="font-size: 13px;">{{$t('date')}}:{{time}}</p>
        </div>
      </div>
      <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt}">
        <tr>
          <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
          <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
        </tr>
        <tr>
          <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
          <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
        </tr>
        <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
        <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>
        <tr>
          <td class="td1 td4">{{$t('disType')}}</td><td colspan="9" class="td4">{{statics.medical_history}}</td>
          <!--<td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>-->
        </tr>
      </table>
      <div class="small-hr"></div>

      <div v-show="!haveData" class="no-data">
        No Data
      </div>
      <div v-show="haveData">
        <div v-for="(base, p) in pagePos">
          <div v-if="p>=1">
            <div class="page-seperator"></div>
            <div class="page-starter">
              <!--<br/><br/><br/><br/>-->
            </div>
          </div>

          <table class="alert-table-header">
            <tr>
              <td width="30%">Time</td>
              <td width="20%">Type</td>
              <td>Alert</td>
            </tr>
          </table>

          <table class="alert-table" v-for="(item, index) in alerts.slice(base, base+perPage[p])" :id="'tbl'+base+index">
            <tr :class="(index%2===0) ? '':'x_even'">
              <td width="30%">{{item[0]}}</td>
              <td width="20%">{{item[3]}}</td>
              <td>{{item[1]}}</td>
            </tr>
          </table>
        </div>
      </div>


      <div class="page-end"></div>

    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  import format from '@/lib/format'

  export default {
    data() {
      return {
        uid:0, et:0,st:0, time:'',isEn:false,foodCoor:'',unit:'',isMg:'',glucoseUnit:'',ts:[],hypo:3.1,high:10.0,low:5.6,isDe:false,isIt:false,
        statics:{},devices:['--','--','--'],hb1c:['--'],target:'',avg:'--',active:'--',seg : ['--','--','--','--'],sd:'--',cv:'--',
        //est_a1c:'--',
        alerts:[],pagePos:[],perPage:[],chartEndPage:{show:false},

      }
    },
    methods: {
      getAlertReportInfo(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/alert',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0) {
            let data =  res.data.data;
            console.log('alert report:', res.data);
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            if ('EasyPatch'==this.devices[0]) {
              document.getElementById('reportPdmTitle').innerHTML='APP';
            }
            this.hb1c = (data.hba1cList)?data.hba1cList:this.hb1c;
            //setTimeout(auth._printPdf(),2000);
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      getAlertTypeText (alertTypeValue) {
        let alertTypeSelect=parseInt(alertTypeValue);
        let alertType='--';
        let AlertTypeTexts=[
          this.$t('PDM'),
          this.$t('Pump'),
          this.$t('CGM')
        ];
        if (alertTypeSelect==NaN || alertTypeSelect<1 || alertTypeSelect>3) {

        } else {
          alertType=AlertTypeTexts[alertTypeSelect-1];
        }
        //console.log('alertType:', alertTypeSelect, alertType, alertTypeValue);
        return alertType;
      },
      procAlertData(alerts) {
        let isEn=this.isEn;
        let that=this;
        let getAlertTypeTextFunc=this.getAlertTypeText;

        alerts = alerts.filter(function(e, i){
          return e[1];
        });

        return alerts.map(function(e, i){
          let item=[];
          //item[0]=new Date(e[0]*1000);
          item[0]=(isEn)?format.formatterDate1(new Date(e[0]*1000)):format.formateDate(new Date(e[0]*1000));
          //item[1]=e[1];
          let alert_sid='Alerts_'+e[1].replace(/ /g, '_');
          item[1] = that.$t(alert_sid);
          item[2]=e[2];
          item[3]=getAlertTypeTextFunc(e[3]);
          return item;
        })
      },

      getAlertData(){
        this.ts = auth.getTs(this.st,this.et);
        //auth.getDashboard(this,this.uid,param);
        //if(this.dayNum>7){
        //  this.openFullScreen();
        //}
        //this.$http.get('/api/v2.1/')

        let params={
          st:this.st,
          et:this.et,
          //alert_type:this.alertTypeSelect
        }
        this.$http.get('/api/v2.1/alerts/'+this.uid, {params:params}).then(function(res){
          //console.log('getAlertData:', res);
          if (0==res.data.error) {
            let alerts=this.procAlertData(res.data.alerts);
            if (alerts.length>0) {
              this.alerts=alerts;
              this.haveData=true;
            } else {
              this.haveData=false;
            }
            console.log('alerts:', alerts);

            if (false) {  // 测试数据
              let item=this.alerts.slice(0,1)[0];
              console.log('alert test:', item);
              for (let i=0; i<100; i++) {
                let temp=item.slice(0, item.length);
                temp[1]=temp[1]+'#'+(i+1);
                this.alerts.push(temp);
              }
              this.haveData=false;
            }

            let page_index=0;
            let PER_PAGE1=22;
            let PER_PAGE2=26;
            while (page_index < this.alerts.length) {
              this.pagePos.push(page_index);
              if (1==this.pagePos.length) {
                page_index += PER_PAGE1;
                this.perPage.push(PER_PAGE1);
              } else {
                page_index += PER_PAGE2;
                this.perPage.push(PER_PAGE2);
              }
            }

          }

        }, function(err){});
      },

      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('Alerts Report');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.glucoseUnit=(this.isMg)?'mg/dL':'mmol/L';
      this.unit = (this.isMg)?' mg/dL':' mmol/L';
      this.hypo = (this.isMg)? 54:3.1;
      this.sgMax = (this.isMg)? 400:25;

      //let st = sessionStorage.getItem('st7');
      //let et = sessionStorage.getItem('et7');
      let st = sessionStorage.getItem('qst1');
      let et = sessionStorage.getItem('qet1');
      this.st = parseInt(st);
      this.et =  parseInt(et);
      this.ts = [[this.st,this.et+86400]];
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }

      param = B64.base64encode(JSON.stringify(param));
      this.getAlertReportInfo(param);
      //this.time =sessionStorage.getItem('timeRange7');
      this.time = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.et);

      this.getAlertData();
    },
  }
</script>
<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    padding-top: 5mm;
    width: 100%;
    *min-height: 377mm;
    min-height: 290mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    *min-height:377mm;
    min-height: 290mm;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }


  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }
  .sgTable td{
    height:30px;
  }

  .bolCount p{
    height: 15px;
  }
  .countLabel{
    width: 96.5%;
    height: 15px;
    margin-left: 1.5%;
    font-family:SFUIText-Regular;
    font-size:12px;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .countLabel td{
    border:none;
    * border: 1px solid #ccc;
  }

  .statics-table tr{
    height:25px;
  }

  #est-a1c div {
    margin-bottom:5px;
  }

  .chart-container .row1 div{
    float:left;
  }

  .page-break {
    page-break-before: always;
  }

  .page-end {
    clear: both;
    height:10mm;
  }

  .page-seperator {
    *height:20mm;
    page-break-before: always;
  }

  .page-starter {
    height:10mm;
  }

  /*表格*/
  table{
    width:94%;
    border-collapse: collapse;
    margin:0 auto;
  }

  .no-data {
    width:94%;
    margin:0 auto;
    font-size:18px;
  }

  .alert-table-header tr{
    color:#005dac;
    height:45px;
    background:#cfdff0;
    font-size:18px;
    text-align:center;
  }

  .alert-table tr{
    *color:#005dac;
    height:40px;
    *background:#cfdff0;
    font-size:18px;
    text-align:center;
  }

</style>



// WEBPACK FOOTER //
// quickPrint10.vue?41810a06